import * as React from "react";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router";
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Checkbox,
  Divider,
  Stack,
  Typography,
} from "@mui/material";

function ProductCategory({

  setSelectedCat,
  setSelectCheck = () => {},
  selectedCat = [],
  flag,
  category_id,
  setHasFilterApplied = () => {},
}) {
  const [checked, setChecked] = useState([]);
  const [data, setData] = useState([]);
  const location = useLocation();

  const handleToggle = (value) => () => {
    let newChecked = [...checked];

    if (newChecked.includes(value)) {
      newChecked = newChecked.filter((id) => id !== value);
    } else {
      newChecked.push(value);
    }

    setChecked(newChecked);

    if (flag == 1) {
      setSelectCheck(newChecked);
    } else {
      setSelectedCat(newChecked);
    }
    window.scrollTo({ top: 0, behavior: "auto" }); // or 'auto'
  };

  useEffect(() => {
    if (flag == 1) {
      setChecked(selectedCat);
      setHasFilterApplied(true);
    }
  }, [flag, selectedCat]);

  useEffect(() => {
    setChecked([]); // reset checked filters
    // if (flag == 0) {
      setSelectedCat([]); // also reset selectedCat outside
    // }
  }, [category_id, location.pathname]);

  async function getSubCategory() {
    try {
      let response = await fetch(
        "https://app.thesoyara.com/index.php?r=api/type-list",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      let result = await response.json();
      if (response.ok) {
        if (result) {
          let filterCategory = result.filter(
            (item) => item.category_id == category_id
          );
          setData(filterCategory);
        }
      } else {
        throw new Error("Something went wrong");
      }
    } catch (error) {
      throw new Error("Something went wrong");
    }
  }

  useEffect(() => {
    getSubCategory();
  }, [category_id]);

  return (
    <div className="product__category">
      <div>
        <h4>SELECT FILTER</h4>
        <Stack direction="row" spacing={2}>
          <List sx={{ width: "100%", bgcolor: "background.paper" }}>
            {data.map((item) => {
              const labelId = `checkbox-list-label-${item.id}`;

              return (
                <ListItem
                  key={item.id}
                  sx={{ padding: 0, height: "32px" }}
                  // secondaryAction={<span>({item.curent_number})</span>}
                >
                  <ListItemButton
                    onClick={handleToggle(item.id)}
                    sx={{ pt: 0, pb: 0, height: "100%" }}
                  >
                    <Checkbox
                      size="small"
                      edge="start"
                      checked={checked.includes(item.id)}
                      inputProps={{ "aria-labelledby": labelId }}
                      sx={{
                        color: "#dfe2e1",
                        "&.Mui-checked": {
                          color: "#fa8f47",
                        },
                      }}
                    />

                    <ListItemText id={labelId}>
                      <span>{item.name}</span>
                    </ListItemText>
                  </ListItemButton>
                </ListItem>
              );
            })}
          </List>
        </Stack>
      </div>
      {/* <div>
        <h4>Occassion</h4>
        <Stack direction="row" spacing={2}>
          <List sx={{ width: "100%", bgcolor: "background.paper" }}>
            {["Maternity", "Pre wedding"].map((value) => {
              const labelId = `checkbox-list-label-${value}`;

              return (
                <ListItem key={value} sx={{ padding: 0, height: "32px" }}>
                  <ListItemButton
                    onClick={handleToggle(value)}
                    sx={{ pt: 0, pb: 0, height: "100%" }}
                  >
                   
                    <Checkbox
                      size="small"
                      edge="start"
                      checked={checked === value}
                      inputProps={{ "aria-labelledby": labelId }}
                      sx={{
                        color: "#dfe2e1",
                        "&.Mui-checked": {
                          color: "#fa8f47",
                        },
                      }}
                    />
                    
                    <ListItemText
                      id={labelId}
                      primary={`Line item ${value + 1}`}
                    />
                  </ListItemButton>
                </ListItem>
              );
            })}
          </List>
        </Stack>
      </div> */}
    </div>
  );
}
export default ProductCategory;
